import { api } from '../index';

const prefix = '/api/basic_info/pick_order/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectPickOrderList(param) {
	return api.post(prefix + 'selectPickOrderList', param);
}

export function apiUpdatePickOrder(param) {
	return api.post(prefix + 'updatePickOrder', param);
}
